import React, {useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../lib/apiUtils";
import FsLightbox from "fslightbox-react";



// ✅ Extract categories dynamically from the product data
const getCategoriesFromProducts = (products) => {
  const categoriesSet = new Set();

  products.forEach((product) => {
    if (product.category.length > 0) {
      product.category.forEach((cat) => categoriesSet.add(cat.name));
    } else {
      categoriesSet.add("Other"); // Assign to "Other" if no category is found
    }
  });

  return ["All", ...Array.from(categoriesSet)];
};

const ProductSection = () => {
  const { t , i18n } = useTranslation();
  let language = i18n.language.includes('en') ? 'en' : 'it';


  const [activeCategory, setActiveCategory] = useState("All");
  const [visibleCount, setVisibleCount] = useState(12); // Show 12 products initially
  const [products, setProductsData] = useState([]); // Set initial value as an empty array
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

    const [toggleSingle, setToggleSingle] = useState(false);
    const [singleImage, setSingleImage] = useState(false);


   // API LOADING
   useEffect(() => {
    setLoading(true);
    setError('')
    setProductsData([]);
    API.get(`/products?lang=${language}`)
      .then((response) => {
        setProductsData(response || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
        setError(err);
        setLoading(false);
      });
  }, [language]);
   const categories = useMemo(() => getCategoriesFromProducts(products), [products]);

  const filteredProducts =
    activeCategory === "All"
      ? products
      : products.filter((product) =>
          product.category.length > 0
            ? product.category.some((cat) => cat.name === activeCategory)
            : activeCategory === "Other"
        );


  const visibleProducts = filteredProducts.slice(0, visibleCount);

  return (

      <>
          <div className="absolute">
              <FsLightbox
                  className={"bg-[#3c86a7b3]"}
                  toggler={toggleSingle}
                  disableLocalStorage={true}
                  sources={[singleImage]}
                  type="image"
              />

          </div>
          <section className="container mx-auto px-6 py-16 text-center" id="products">
              {isLoading && <div>Loading...</div>}
              {error && <div>Error .. </div>}
              <h4 className="text-main-100 uppercase tracking-widest sec-head-font ">
                  {t("sections.products")}
              </h4>
              <h2 className="text-3xl sec-breif-font text-bf-100 mt-2">{t("sections.product_title")}</h2>
              <p className="text-dc-100  leading-relaxed  sec-desc-font mt-4 max-w-2xl mx-auto">{t("sections.product_description")}</p>

              <div className="mt-8 flex justify-center mx-auto flex-wrap gap-2 max-w-2xl">
                  {categories.map((category) => (
                      <button
                          key={category}
                          className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${
                              activeCategory === category
                                  ? "bg-main-100 text-white border-main-100 shadow-md"
                                  : "bg-white text-gray-600 border-gray-200 hover:border-main-100 hover:text-main-100"
                          }`}
                          onClick={() => {
                              setActiveCategory(category);
                              setVisibleCount(12);
                          }}
                      >
                          {category}
                      </button>
                  ))}
              </div>



              <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 ">
                  {visibleProducts.map((product) => (
                      <div
                          key={product.id}
                          className="bg-gl-200  rounded-2xl shadow-lg overflow-hidden    cursor-pointer"
                          onClick={() => {
                              setSingleImage(product.image);
                              setToggleSingle(!toggleSingle);
                          }}
                      >
                          <img
                              src={product.image || "/images/placeholder.jpg"}
                              alt={product.title}
                              className="w-full object-contain rounded-lg"
                          />
                      </div>
                  ))}
              </div>


              {visibleCount < filteredProducts.length && (
                  <button
                      onClick={() => setVisibleCount((prev) => prev + 12)}
                      className="mt-10 px-8 py-2.5 border-2 border-main-100 text-main-100 rounded-full font-medium hover:bg-main-100 hover:text-white transition-all duration-200"
                  >
                      {t("sections.show_more")}
                  </button>
              )}


          </section>


      </>


  );
};

export default ProductSection;
